import React from 'react';
import styles from './ViewToggle.module.css';

interface ViewToggleProps {
  value: 'card' | 'grid';
  onChange?: (v: 'card' | 'grid') => void;
}

export const ViewToggle: React.FC<ViewToggleProps> = ({ value, onChange }) => {
  return (
    <div className={styles.toggle}>
      <button
        className={`${styles.option} ${value === 'card' ? styles.active : ''}`}
        onClick={() => onChange?.('card')}
      >
        ▦ Card
      </button>
      <button
        className={`${styles.option} ${value === 'grid' ? styles.active : ''}`}
        onClick={() => onChange?.('grid')}
      >
        ☷ Grid
      </button>
    </div>
  );
};
